const DEFAULT_MAX_FILES = 10;
const DEFAULT_MAX_SIZE = 100 * 1024 * 1024; // 100MB

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        const [, base64 = ''] = result.split(',');
        resolve(base64);
      } else {
        reject(new Error('Unsupported file reader result.'));
      }
    };
    reader.onerror = () => {
      reject(new Error(`Failed to read file: ${file.name}`));
    };
    reader.readAsDataURL(file);
  });
}

export async function buildAttachmentsFromFileList(fileList, existingCount = 0, options = {}) {
  const files = Array.from(fileList || []);
  if (files.length === 0) {
    return {
      attachments: [],
      errors: {
        tooManyFiles: false,
        oversizedFiles: [],
        remainingSlots: Math.max(0, (options.maxFiles ?? DEFAULT_MAX_FILES) - existingCount),
      },
    };
  }

  const maxFiles = options.maxFiles ?? DEFAULT_MAX_FILES;
  const maxSize = options.maxSize ?? DEFAULT_MAX_SIZE;

  const remainingSlots = Math.max(0, maxFiles - existingCount);
  if (files.length > remainingSlots) {
    return {
      attachments: [],
      errors: {
        tooManyFiles: true,
        oversizedFiles: [],
        remainingSlots,
        maxFiles,
      },
    };
  }

  const oversizedFiles = [];
  const attachments = [];

  for (const file of files) {
    if (file.size > maxSize) {
      oversizedFiles.push({
        name: file.name,
        size: file.size,
      });
      continue;
    }

    try {
      const content = await readFileAsBase64(file);
      attachments.push({
        id: Math.random().toString(36).slice(2, 11),
        name: file.name,
        content,
        size: file.size,
        type: file.type || 'application/octet-stream',
      });
    } catch (error) {
      console.error('[aiPromptAttachments] Unable to read file', file.name, error);
      oversizedFiles.push({
        name: file.name,
        size: file.size,
        error: error.message,
      });
    }
  }

  return {
    attachments,
    errors: {
      tooManyFiles: false,
      oversizedFiles,
      remainingSlots: remainingSlots - attachments.length,
      maxFiles,
    },
  };
}

export function removeAttachmentById(attachments = [], attachmentId) {
  return attachments.filter((attachment) => attachment.id !== attachmentId);
}

export const MAX_PROMPT_ATTACHMENTS = DEFAULT_MAX_FILES;
export const MAX_PROMPT_ATTACHMENT_SIZE = DEFAULT_MAX_SIZE;
